import moment from 'moment';
// import findNested from '../helpers/findNested';

var findNested = function(obj, key, value) {
    if (obj[key] === value) {
        return obj;
    } else {
        for (var i = 0, len = Object.keys(obj).length; i < len; i++) {
            if (typeof obj[i] == 'object') {
                var found = findNested(obj[i], key, value);
                if (found) {
                    // If the object was found in the recursive call, bubble it up.
                    return found;
                }
            }
        }
    }
};

export default contact => {
    let priorityTicketing = false;
    if (contact.subscriptions) {
        priorityTicketing = findNested(contact.subscriptions, 'ffa_name', 'FF_SUB') || false;
    }

    return {
        user: {
            birthdate: contact.birthdate ? moment(contact.birthdate).format('YYYY-MM-DD') : '',
            email: contact.emailaddress1 || (contact.email || ''),
            family_name: contact.lastname || (contact.lastName || (contact.family_name || '')),
            given_name: contact.firstname || (contact.firstName || (contact.given_name || '')),
            displaymobilephone: contact.ffa_displayaddress || false,
            mobilephone: contact.mobilephone || '',
            displayaddress: contact.ffa_displayaddress || false,
            priority_ticketing: priorityTicketing.ffa_membershipstatus || false,
            address1_line1: contact.address1_line1 || '',
            address1_line2: contact.address1_line2 || '',
            address1_city: contact.address1_city || '',
            address1_stateorprovince: contact.address1_stateorprovince || '',
            address1_postalcode: contact.address1_postalcode || '',
            address1_country: contact.address1_country || '',
            accountType: contact.accountType || 'Free',
            plusAccountCreatedAt: contact.plusAccountCreatedAt || null,
            fifaTicketCode: contact.fifaTicketCode || null,
            id_verified: contact.id_verified || null
        },
        form: {
            onboarding: contact.ffa_preferenceonboardingform || "New",
            onboardingcomplete: contact.ffa_preferenceonboardingcompleted || contact.onboardingcomplete || "Skipped",
            isprimary: contact.ffa_primarycontact || true,
            ffa_bulkemailfrequency: (contact.ffa_bulkemailfrequency && contact.ffa_bulkemailfrequency == 'Break') ? true : false,
            ffa_donotbulkmobile: JSON.parse(contact.ffa_donotbulkmobile ? contact.ffa_donotbulkmobile.toString().toLowerCase() : 'false'),
            ffa_donotbulkemail: contact.donotbulkemail || false,
            ffa_unsubscribereason: contact.ffa_unsubscribereason || null,
            ffa_unsubscribereasonother: contact.ffa_unsubscribereasonother || null
        },
        disable_communication_group: {
            ffa_donotbulkemail: JSON.parse(contact.ffa_donotbulkemail ? contact.ffa_donotbulkemail.toString().toLowerCase() : 'false'),
            ffa_donotbulkmobile: JSON.parse(contact.ffa_donotbulkmobile ? contact.ffa_donotbulkmobile.toString().toLowerCase() : 'false'),
        },
        clubs_supported: contact.clubs_supported || {},
        subscriptions: contact.subscriptions || []
    };
};
